import Tabs from "./tabs"
import Tab from "./tabs.tab"

export { Tab }
export default Tabs
